import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

export async function getTransactions() {
  try {
    const {data} = await axios.get('/api/profile/transations');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      throw new Error('Bag request')
    }
  } catch (error) {
  }
}

export async function sendOrder(body, formatMessage) {
  try {
    const {data} = await axios.post('/api/profile/send-transaction', body);
    if(data.errcode == 200) {
      toastr.success(formatMessage('sendTrTitle'), formatMessage('sendTrMessage'))
      return data.payload;
    } else {
      throw new Error('Bag request')
    }
  } catch (error) {
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Transaction/actions.js